/**
 * Dual Firebase Project Configuration
 * 
 * Project 1: Core SIS (READ ONLY) — Master database
 * Project 2: Exam System — Operational database
 * 
 * CRITICAL: Never write to Core SIS from this application.
 */
import { initializeApp } from 'firebase/app';
import { getFirestore, enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// ─── Firebase Project 1: Core SIS (Single Source of Truth) ───
const coreSISConfig = {
  apiKey: "AIzaSyATaG7a66tT--OaOyr4xCD8ck-sfmRv_hY",
  authDomain: "core-sis.firebaseapp.com",
  projectId: "core-sis",
  storageBucket: "core-sis.firebasestorage.app",
  messagingSenderId: "171171484264",
  appId: "1:171171484264:web:c331d392beeb781ea3a1dd",
  measurementId: "G-CVX0RXG7M6"
};

// ─── Firebase Project 2: Exam System (Operational Database) ───
const examSystemConfig = {
  apiKey: "AIzaSyCUF9IkHXKKooisEnxZJv0lcGKV5wwye5w",
  authDomain: "aliman-exam-system.firebaseapp.com",
  projectId: "aliman-exam-system",
  storageBucket: "aliman-exam-system.firebasestorage.app",
  messagingSenderId: "1094217250561",
  appId: "1:1094217250561:web:9f19c7e46d57acf880cd00"
};

// Initialize Firebase Apps
const coreSISApp = initializeApp(coreSISConfig, 'core-sis');
const examApp = initializeApp(examSystemConfig);

// ─── Firestore Instances ───
/** Core SIS Firestore — READ ONLY. Never write to this instance. */
export const coreSISDb = getFirestore(coreSISApp);

/** Exam System Firestore — All exam operational data. */
export const examDb = getFirestore(examApp);

// ─── Authentication (from Core SIS) ───
export const auth = getAuth(coreSISApp);

// Export app instances for advanced usage
export { coreSISApp, examApp };

// ─── Enable Offline Persistence (fire-and-forget, non-blocking) ───
// Reduces Firestore reads on page reload by serving cached data first.
// Gracefully handles: multiple tabs, unsupported browsers, private mode.
enableMultiTabIndexedDbPersistence(examDb).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Firestore persistence (examDb): multiple tabs open, persistence enabled in first tab only.');
  } else if (err.code === 'unimplemented') {
    console.warn('Firestore persistence (examDb): browser does not support IndexedDB persistence.');
  }
});

enableMultiTabIndexedDbPersistence(coreSISDb).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Firestore persistence (coreSISDb): multiple tabs open, persistence enabled in first tab only.');
  } else if (err.code === 'unimplemented') {
    console.warn('Firestore persistence (coreSISDb): browser does not support IndexedDB persistence.');
  }
});
